import $ from 'jquery';
import buildMap from 'lib/maps';
import tdaConfig from 'lib/util/tda.config';
import responsive from 'lib/responsive';
import langFromUrl from 'lib/util/langFromUrl';
import Slicker from 'components/slicker';
import modernizr from 'modernizr';
import bat from 'components/bat'; // bat.hcompile
import compare from 'features/ctas/compare.cta';
import dealerDirections from 'features/ctas/dealer.directions.cta';
import dealerChat from 'features/ctas/dealer.chat.cta';
import blocks from 'lib/analytics/blocks/index';
import anComponentView from 'lib/analytics/componentView';
import anClicks from 'lib/analytics/click';
import 'lib/helpers/offer-bundle';
import breadCrumbs from 'features/breadcrumbs/breadcrumbs';

var MOVE_SLIDES_DESKTOP = 3;

// BAT-3014 FORMATS LINK NUMBERS TO BE NUMBERS ONLY, ADD 1 AT TOP IF NEEDED.
function __formatPhoneLink(pn) {
  pn = pn.replace(/[^0-9]/g, '');
  if (pn.charAt(0) !== '1') {
    pn = '1' + pn;
  }
  return pn;
}

var dealerDetail = {
  $el: $('#dealer-detail'),
  service: '/BATWS/tooms/search/offers',
  serviceParams: {
    dealerCode: ''
  },

  load: function (el) {
    this.$el = $(el);
    this.dealerCode = this.$el.data('dealercode');
    this.init();
    this.analytics();
  },

  analytics: function () {
    anComponentView(this.$el, blocks.keyMetrics('km-dealer-detail'));
    anClicks(this.$el);
  },

  init: function () {
    var self = this;
    $('#main-wrapper-column').addClass('wrap-white'); // white BG on this page
    buildMap()
      .then(function (MapsConstructor) {
        self.drawMap(MapsConstructor);
      })
      .catch(function (err) { console.log('err in maps: ', err); });
    /*------------------------------------------------------------------
    Timing issue in production where TOOMS and displayContactAtOnceCta
    were failing, because this.serviceParams.dealerCode was undefined.
    populate it on init instead
    --------------------------------------------------------------------*/
    this.serviceParams.dealerCode = this.dealerCode;
    this.setupAwards();
    this.dealerData();
    this.getTOOMS();
    this.customCTAs();
    this.dealerCtas();

    // Update phone # and tel link in the all numbers table, using default phone from DOM
    var $dealerPhone = $('.dealer-phone-main');
    var dealerPhoneNum = $dealerPhone.data('phone');
    var dealerPhoneLink = $dealerPhone.children('a').attr('href');
    $('.js-all-phone').attr('href', dealerPhoneLink).text(dealerPhoneNum);

    $('.phone-number-new').each(function (idx, item) {
      var txt = $(item).text();
      var fmt = __formatPhoneLink(txt);
      var telLink = ('tel:' + fmt);
      $(item).attr('href', telLink);
    });

    // TODO: update days of week with spanish text on /es/ ?

    if ($('.certification-indicator div').length > 0) {
      $('.certification-item').removeClass('hidden');
      // $('.certification-bullet').removeClass('hidden');
    }

    if ($('.language-bullet').length > 0) {
      $('.language-item').removeClass('hidden');
    }

    breadCrumbs.updateDealerDetailBreadcrumb();
  },

  dealerCtas: function () {
    var address = $('.detail-more-address p a').html().replace(',', '');// example: "1605 VFW ParkwayBoston, MA 02132"
    var urlfa = address.replace(/ /g, '+');
    dealerDirections(this.$el, encodeURI(urlfa));
    dealerChat(this.$el, this.dealerCode);
    compare(undefined, undefined, this.$el);
  },

  drawMap: function (MapsConstructor) {
    var draggable = true;
    if (responsive() === 'sm') {
      draggable = false;
    }
    var detailMap = new MapsConstructor({
      kind: 'direction',
      $form: $('.m-direction-form'),
      mapOptions: {
        zoom: 17,
        backgroundColor: '#ccc',
        draggable: draggable,
        mapTypeControl: false,
        fullscreenControl: false,
        streetViewControl: true,
        zoomControl: true,
      },
      mapElement: document.getElementById('map-canvas')
    });
  },

  customCTAs: function () {
    // Add custom CTA link logic here
    $("a[data-destination='custom']").each(function (i, customCTALink) {
      var $this = $(this);
      var customUrl = $this.attr('href');
      // console.log("customUrl: " + customUrl);
      var customUrlArr = customUrl.split('/'); // split it into an array, so we can drop the unused parts
      if (customUrlArr[1] == 'sites') {
        customUrlArr.splice(0, 3); // Drop the first 3 items from array ('', 'sites', 'TDA')
        customUrlArr.unshift('/' + tdaConfig.site.context_url);
      }

      var finalUrl = customUrlArr.join('/'); // create URL from array
      // console.log("finalUrl: " + finalUrl);
      $this.attr('href', finalUrl);
    });
  },

  getTOOMS: function () {
    var self = this;
    $.getJSON(self.service, self.serviceParams).done(function (data) {
      self.resp = data.results;
      self.insertData();
      // console.info('TOOMS DATA:', data);
    });
  }, // END getTOOMS

  insertData: function () {
    var dataArray = [];
    // If there are results, proceed
    if (this.resp) {
      if (this.resp.offerDTOs) {
        for (var x = 0; x < this.resp.totalOffersFound; x++) {
          dataArray = dataArray.concat(this.resp.offerDTOs[x]);
        }
      }

      $.each(dataArray, function (index, value) {
        if (value.offerDetailsImagePath.indexOf('.pdf') > 0) {
          value.offerImageType = 'pdf';
        }
      });
    }

    var offerCardTemplate = $('#template-offercards').html();
    var offerCardHandlebar = bat.hcompile(offerCardTemplate, {
      data: dataArray
    });
    var offerModalTemplate = $('#template-offermodal').html();
    var offerModalHandlebar = bat.hcompile(offerModalTemplate, {
      data: dataArray
    });

    $('.data-toomscards').html(offerCardHandlebar);
    $('body').append(offerModalHandlebar);

    if (dataArray.length > 0) {
      // TODO: test this
      // if (data.results.totalOffersFound > 0){
      //  $('#section-details-offers').show();
      // }
      $('#section-details-offers').show();
    }

    this.initCard();
  }, // END insertData

  initCard: function () {
    var $component = $('#tooms-slider');
    if ($component.find('.card').length > 2) {
      var isTouch = modernizr.touch;
      var strip = new Slicker({
        $slider: $component.find('.offer-cards-slider'),
        slickOptions: {
          mobileFirst: true,
          infinite: false,
          slide: '.card',
          slidesToShow: 1.5,
          slidesToScroll: 1,
          useCSS: true,
          autoplay: false,
          adaptiveHeight: false,
          dots: true,
          initFunction: function () {
            var $boxPagerItem = $component.find('.datalayer-link-slick-dot');
            $boxPagerItem.off().on('click', function () {
              if (isTouch) {
                return false;
              }
            });
          },
          beforeFunction: function (e, slick, currentSlide, nextSlide) {
            setShadow(nextSlide, slick.slideCount);
          },
          desktop: {
            slidesToShow: 3.5,
            slidesToScroll: 3.5,
            draggable: false,
          },
          tablet: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }
      });
      // store service carousel, so we can reload it later
      dealerDetail.currentServiceCarousel = strip.slider;
    } else {
      // var url = document.location.toString();
      // if (!url.match('#')) {
      // this.filterByTab('#general-info');
      // }
      dealerDetail.currentServiceCarousel = '';
    }

    function setShadow(nextSlide, slideCnt) {
      var currentSlide = (nextSlide + 1) * MOVE_SLIDES_DESKTOP;

      if (currentSlide >= slideCnt) {
        $component.find('.slick-list').addClass('left-shadow');
      } else {
        $component.find('.slick-list').removeClass('left-shadow');
      }
    }
  },

  setupAwards: function () {
    // Show or hide the awards
    var $certBullets = $('#certification-bullets');

    if ($certBullets.find('.cab-award').length) {
      $('.CAB').show();
    }

    if ($certBullets.find('.bog-award').length) {
      $('.BOG').show();
    }

    if ($certBullets.find('.pa-award').length) {
      $('.presidents-award').show();
    }

    // to show or hide the awards based on language
    if (langFromUrl() === 'en') {
      $('.certification-bullet.es-data').hide();
    } else {
      $('.certification-bullet.en-data').hide();
    }
  },

  // Not yet used
  dealerData: function () {
    var self = this;
    $.ajax({
      dataType: 'json',
      url: '/BATWS/geo/rest/filterMode/getDealerDetails',
      data: {
        dealerCode: self.dealerCode,
        begin: 1,
        end: 1
      },
      beforeSend: function (xhrObj) {
        xhrObj.setRequestHeader('Content-Type', 'application/json');
        xhrObj.setRequestHeader('Accept', 'application/json');
        xhrObj.overrideMimeType('application/json');
      }
    }).done(function (data) {
      // console.group('dealerDetail.dealerData');
      // console.log(data);
      var is_mirai = dealerDetail.isDealerLocatorResultMirai(data.dealerLocator[0]);
      if (is_mirai) {
        $('.mirai-logo').show();
      }
      // console.log('full dealerDetail data: ', data.dealerLocator[0]);
      // dealerDetail.paintAllHoursTable(data.dealerLocator[0].dealerLocatorDetail.hoursOfOperation);
      dealerDetail.paintAllHoursTableCondensed(data.dealerLocator[0].dealerLocatorDetail.hoursOfOperation);
      // console.groupEnd();
    }).fail(function (jqXHR, textStatus, errorThrown) {
      // console.log('ERROR');
      // console.log(textStatus, errorThrown);
    });
  },

  dealerTimeConvert: function (dealerMinutes) {
    if (!dealerMinutes) {
      return '-';
    }
    var hour = Math.floor(dealerMinutes / 60);
    var remainder = dealerMinutes % 60;
    var colon = ':';
    if (remainder === 0) {
      colon = '';
      remainder = '';
    }

    var dayMode = hour < 12 ? 'AM' : 'PM'; // if it's less than 12 then "AM"
    var hours12 = hour <= 12 ? (hour == 0 ? 12 : hour) : hour - 12;
    return hours12 + colon + remainder + dayMode;
  },

  paintAllHoursTableCondensed: function (hoursData) {
    // get only General, Sales, Service data
    var deptsToGet = ['general', 'sales', 'service'];
    var deptsTemp = [];
    // for each department
    for (var i = 0; i < hoursData.length; i++) {
      var currDept = hoursData[i].hoursTypeCode.toLowerCase();
      if (deptsToGet.indexOf(currDept) > -1) {
        // deptsTemp.push(hoursData[i]);
        // for mon - sat push start minutes into array
        var tmp = [];
        var prevDayHourOpen = hoursData[i].daysOfWeek[0].availabilityStartTimeMeasure.value;
        var prevDayHourClose = hoursData[i].daysOfWeek[0].availabilityEndTimeMeasure.value;
        var prevDayCode = hoursData[i].daysOfWeek[0].dayOfWeekCode;
        var usedDays = [];
        var usedDaysIndex = [];
        var nextDays = [];
        var daysOutput;
        // console.log('Very first prevDayHour: ' + prevDayHourOpen);
        for (var j = 0; j < 6; j++) {
          var curHourOpen = hoursData[i].daysOfWeek[j].availabilityStartTimeMeasure.value;
          var curHourClose = hoursData[i].daysOfWeek[j].availabilityEndTimeMeasure.value;
          var curDayCode = hoursData[i].daysOfWeek[j].dayOfWeekCode;
          usedDays.push(curDayCode);
          usedDaysIndex.push(j);

          // we found a day that does not match
          if (curHourOpen !== prevDayHourOpen || curHourClose !== prevDayHourClose) {
            // drop the last day, and work with all the previous days
            usedDays.pop();
            nextDays.push(curDayCode);
            /* var hourOpen = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[0].availabilityStartTimeMeasure.value); // Always Monday
            var hourClose = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[0].availabilityEndTimeMeasure.value); // Always Monday */

            var usedDay1 = usedDays[0];
            var usedDay2 = usedDays[usedDays.length - 1];
            if (usedDay1.toLowerCase() === usedDay2.toLowerCase()) {
              daysOutput = usedDay1;
            } else {
              daysOutput = usedDay1 + ' - ' + usedDay2;
            }

            $('#js-hours-' + currDept).append('<tr><td>' + daysOutput + '</td><td>' + dealerDetail.dealerTimeConvert(prevDayHourOpen) + ' - ' + dealerDetail.dealerTimeConvert(prevDayHourClose) + '</td></tr>');

            usedDays = []; // now empty usedDays
            usedDaysIndex = [];
            usedDays.push(curDayCode);
            usedDaysIndex.push(j);
            // $('#js-hours-' + currDept).append('<tr><td>' + hoursData[i].daysOfWeek[j].dayOfWeekCode + '</td><td>' + hourOpen + ' - ' + hourClose + '</td></tr>');
          }
          prevDayHourOpen = curHourOpen;
          prevDayHourClose = curHourClose;
          // console.log('new PrevDayHour: ' + prevDayHourOpen);
          // tmp.push(hoursData[i].daysOfWeek[j].availabilityStartTimeMeasure.value);
        }
        // console.log('usedDays: ', usedDays)
        // console.log('usedDaysIndex: ', usedDaysIndex)
        // console.log('nextDays: ', nextDays)
        // console.log('tmp: ', tmp);
        var indexToUse = usedDaysIndex[0]; // grab the first item from our index store
        var currOpen = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[indexToUse].availabilityStartTimeMeasure.value);
        var currEnd = dealerDetail.dealerTimeConvert(hoursData[i].daysOfWeek[indexToUse].availabilityEndTimeMeasure.value);
        // prevent "Saturday - Saturday" from appearing

        var day1 = usedDays[0];
        var day2 = usedDays[usedDays.length - 1];
        if (day1.toLowerCase() === day2.toLowerCase()) {
          daysOutput = day1;
        } else {
          daysOutput = day1 + ' - ' + day2;
        }
        $('#js-hours-' + currDept).append('<tr><td>' + daysOutput + '</td><td>' + currOpen + ' - ' + currEnd + '</td></tr>');

        // Sundays:
        var sunOpen = hoursData[i].daysOfWeek[6].availabilityStartTimeMeasure;
        var sunEnd = hoursData[i].daysOfWeek[6].availabilityEndTimeMeasure;
        var sundayHours;
        if (sunOpen == null) {
          sundayHours = '-';
        } else {
          sundayHours = dealerDetail.dealerTimeConvert(sunOpen.value) + ' - ' + dealerDetail.dealerTimeConvert(sunEnd.value);
        }
        $('#js-hours-' + currDept).append('<tr><td>Sunday</td><td>' + sundayHours + '</td></tr>');
      }
    }
  },

  isDealerLocatorResultMirai: function (dealerLocatorResult) {
    var programGrepResults = [];
    var program;
    var isMirai;

    if (dealerLocatorResult && dealerLocatorResult.dealerMetaDataDetail && dealerLocatorResult.dealerMetaDataDetail.additionalService) {
      programGrepResults = $.grep(dealerLocatorResult.dealerMetaDataDetail.additionalService, function (element, index) {
        // return the additionalService with code TDA
        if (element.code) return element.code.value == 'MiraiSales';
      });

      if (programGrepResults.length) {
        program = programGrepResults[0];

        isMirai = program.participationIndicator;
      }
      // console.log('isMirai: ', isMirai);
    }

    if (window.location.pathname.indexOf('dealer-directory') != -1) {
      $('#search-more-dealers').hide();
      return true;
    } else {
      return isMirai;
    }
  },

  paintAllHoursTable: function (hoursData) {
    // get only General, Sales, Service data
    var deptsToGet = ['general', 'sales', 'service'];
    var deptsTemp = [];
    // for each department
    for (var i = 0; i < hoursData.length; i++) {
      var currDept = hoursData[i].hoursTypeCode.toLowerCase();
      // console.log(currDept)
      if (deptsToGet.indexOf(currDept) > -1) {
        // for each day of the week, output hours
        var dayArr = hoursData[i].daysOfWeek;
        for (var j = 0; j < dayArr.length; j++) {
          var currDay = dayArr[j].dayOfWeekCode;
          var currDayStart = dayArr[j].availabilityStartTimeMeasure;
          var currDayEnd = dayArr[j].availabilityEndTimeMeasure;
          if (currDayStart == null) {
            currDayHours = '-';
          } else {
            currDayHours = dealerDetail.dealerTimeConvert(currDayStart.value) + ' - ' + dealerDetail.dealerTimeConvert(currDayEnd.value);
          }
          $('#js-hours-' + currDept).append('<tr><td>' + currDay + '</td><td>' + currDayHours + '</td></tr>');
        }
      }
    }

    // console.log(deptsTemp);

    // console.log(dealerDetail.dealerTimeConvert(1200));

    // $('#js-hours-general').append('<tr><td>Monday - Saturday</td><td></td></tr>');
  },
};

export default dealerDetail;
